import "whatwg-fetch";
import { Component } from "react";
import LinearProgress from "@material-ui/core/LinearProgress";

import { connect } from "react-redux";

import * as ssnActions from "../../../../services/users/actions";

class TableCellSSNComponent extends Component {
  giveSSN = (accountId) => {
    this.props.getSsn(accountId);
  };

  render() {
    let ssnValue = "";
    let accountId = this.props.value;
    let fetching = false;
    let snnObj = this.props.ssn[accountId];
    if (snnObj && snnObj.ssnfetched) ssnValue = snnObj.data.SSN;
    if (snnObj && snnObj.ssnFetching) fetching = true;

    if (fetching) {
      return (
        <div className="table-cell-ssn">
          <LinearProgress />
        </div>
      );
    } else if (ssnValue) {
      return (
        <div className="table-cell-ssn">
          <a
            href={"/user/overview/ssn/" + ssnValue}
            rel="noreferrer"
            target="_blank"
          >
            {ssnValue}
          </a>
        </div>
      );
    } else {
      return (
        <div className="table-cell-ssn">
          <div onClick={this.giveSSN.bind(this, this.props.value)}>Get ssn</div>
        </div>
      );
    }
  }
}

function mapStateToPropsSSN(state) {
  return {
    ssn: state.users.accountInfos,
  };
}

function mapDispatchToPropsSSN(dispatch) {
  return {
    getSsn: (accountId) => {
      dispatch(ssnActions.account_info_fetch_ssn(accountId));
    },
  };
}

export const TableCellSSN = connect(
  mapStateToPropsSSN,
  mapDispatchToPropsSSN,
)(TableCellSSNComponent);
export default TableCellSSN;
